import React from 'react';
import { Container, Col, Row, ListGroup, ListGroupItem, Button } from 'reactstrap';
import { RouteComponentProps } from 'react-router-dom';
import { Recipe } from 'state/recipe/model';

interface Props extends RouteComponentProps<any> {
  recipes: Recipe[],
  fetchRecipes(): void,
  isFetchingRecipes: boolean,
  submitRecipes(ids: string[]): void
}

interface State {
  recipes: Recipe[],
  deletedRecipes: Recipe[]
}

function shuffle(a: any[]) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]]
  }
  return a;
}

export default class RecipePicker extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      recipes: [],
      deletedRecipes: []
    }
  }
  componentDidMount() {
    this.props.fetchRecipes();
  }

  componentDidUpdate(prevProps: Props) {
    if ((prevProps.recipes != this.props.recipes) && (!this.props.isFetchingRecipes)) {
      const { recipes } = this.props;
      if (recipes && recipes.length > 0) {
        this.setState({
          recipes: shuffle(recipes).slice(0, 5)
        });
      }
    }
  }

  get randomRecipe(): Recipe {
    const { recipes } = this.props;
    return shuffle(
      recipes.filter(recipe => !this.state.deletedRecipes.includes(recipe))
    )[0]
  }

  removeRecipeAndAddRandomRecipe = (recipe: Recipe) => {
    const { recipes } = this.props;
    const randomRecipe = shuffle(
      recipes.filter(propRecipe => !this.state.deletedRecipes.includes(propRecipe))
        .filter(rec => !this.state.recipes.includes(rec))
        .filter(rec => rec !== recipe)
    )[0];
    const index = this.state.recipes.indexOf(recipe);
    if (randomRecipe) {
      let localStateRecipes = this.state.recipes;
      localStateRecipes.splice(index, 1, randomRecipe);
      this.setState({
        recipes: localStateRecipes,
        deletedRecipes: [...this.state.deletedRecipes, recipe]
      });
    } else {
      const localStateRecipes = this.state.recipes;
      localStateRecipes.splice(index, 1);
      this.setState({
        recipes: localStateRecipes,
        deletedRecipes: [...this.state.deletedRecipes, recipe]
      })
    }
  }

  submitChoices = () => {
    const ids = this.state.recipes.map(rec => rec.id);
    this.props.submitRecipes(ids);
  }

  render() {
    const { recipes } = this.state;
    if (this.props.isFetchingRecipes) { return <div>Loading...</div> }
    return (
      <div>
        <Container>
          <Row>
            <Col md={10}>
              <h1>Select Your Recipes</h1>
            </Col>
          </Row>
          <Row>
            <Col md={10}>
              <ListGroup>
                {recipes.map(recipe => {
                  return (
                    <ListGroupItem key={recipe.id || recipe.name}>
                      <Row>
                        <Col md={6}>
                          <p>{recipe.name}</p>
                        </Col>
                        <Col md={6}>
                          <Button className="float-right" color="danger" onClick={() => this.removeRecipeAndAddRandomRecipe(recipe)}>x</Button>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  )
                })}
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col md={10}>
              <Button color="primary" onClick={this.submitChoices}>Choose This Weeks Recipes</Button>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}